// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__3rYNa","selects":"Documents_selects__2p7wF"};